import { BrowserOptions } from '@sentry/browser';

export const ignoreErrors: BrowserOptions['ignoreErrors'] = [
  'Network request failed',
  'Failed to fetch',
  // Safari and Firefox spellings of 'Failed to fetch'.
  'Load failed',
  'NetworkError when attempting to fetch resource',
  // Flag fetch failed; the SDK falls back to its local cache.
  'LaunchDarklyFlagFetchError',
  'cannot parse response',
  // https://github.com/WICG/resize-observer/issues/38#issuecomment-493014026
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  // View Transition API rejections, surfaced as unhandled rejections with no
  // stack. A transition aborts whenever it is superseded or the DOM changes
  // mid-capture, which is expected and not something a caller can act on.
  /Transition was (aborted|skipped)/,
  // Badging API throttle from the browser, not from our own badge calls.
  'Too many badges requests in queue',
  'Forbidden resource',
  'Invariant Violation: 9', // to init apollo client, must specify cache prop
  'Invariant Violation: 20', // store reset while query in flight
  'Store reset while query was in flight',
  'JSON Parse error: Unrecognized token',
  'Status code failure 403',
  // Expired token; the app redirects to sign-in.
  'Status code: 401',
  'Requestor is not allowed to access channel',
  // Stale bookmarks, deleted workspaces and mistyped URLs; the app shows its not-found state.
  /^Channel with (slug|id) .* not found$/,
  'Socket closed with event 4500',
  "Invalid business id header 'x-coast-business-id'",
  'Requestor is not allowed to access business',
  // Membership is no longer valid, so every in-flight operation reports it at
  // once — one stale session produces a burst of identical events.
  'User/business relationship invalid',
  // The user mistyped their sign-in code; the form already tells them.
  /^Invalid code\.$/,
];
